import { Icon, Text } from '@fluentui/react';
import { ECompareVMStatus } from 'global/Compare/ComparisonViewModelGenerator';
import React, { CSSProperties } from 'react';

const CONTAINER_STYLE: CSSProperties = {
    display: 'inline-flex',
    justifyContent: 'end',
    alignItems: 'center',
    paddingRight: '20px',
    userSelect: 'none',
    cursor: 'default',
}

const ICON_STYLE: CSSProperties = {
    margin: 0,
    padding: 0,
    fontSize: 18,
    color: 'gray',
}

const LABEL_STYLE: CSSProperties = {
    marginRight: 6,
    fontSize: 10,
    color: 'darkgray',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
    width: '220px',
}

const ICONS_BY_STATUS: Record<ECompareVMStatus, { left: string; right: string; }> = {
    [ECompareVMStatus.Unknown]: { left: 'Error', right: 'Error' },
    [ECompareVMStatus.Identical]: { left: 'Page', right: 'Page' },
    [ECompareVMStatus.Modified]: { left: 'Page', right: 'PageEdit' },
    [ECompareVMStatus.OnTargetOnly]: { left: 'PageSolid', right: 'Page' },
    [ECompareVMStatus.OnOriginOnly]: { left: 'Page', right: 'PageSolid' },
};
const TITLES_BY_STATUS: Record<ECompareVMStatus, string> = {
    [ECompareVMStatus.Unknown]: 'Unknown',
    [ECompareVMStatus.Identical]: 'Matched On Origin and Target - Identical',
    [ECompareVMStatus.Modified]: 'Matched On Origin and Target - Modified',
    [ECompareVMStatus.OnTargetOnly]: 'Available Only on Target',
    [ECompareVMStatus.OnOriginOnly]: 'Available Only on Origin',
};


interface ICompareStatusIndicatorProps {
    compareStatus?: ECompareVMStatus;
    onTargetClick?: () => void;
    onOriginClick?: () => void;

}


export const CompareStatusIndicator: React.FC<ICompareStatusIndicatorProps> = (props) => {
    const icons = ICONS_BY_STATUS[props.compareStatus ?? ECompareVMStatus.Unknown];
    const title = TITLES_BY_STATUS[props.compareStatus ?? ECompareVMStatus.Unknown];

    return (
        <span
            style={CONTAINER_STYLE}
            title={title}
        >
            <Icon
                iconName={icons.left}
                style={ICON_STYLE}
                onClick={props.onOriginClick
                    ? (event) => {
                        event.stopPropagation();
                        props.onOriginClick?.();
                    }
                    : undefined
                }
            />
            <Icon
                iconName={icons.right}
                style={ICON_STYLE}
                onClick={props.onTargetClick
                    ? (event) => {
                        event.stopPropagation();
                        props.onTargetClick?.();
                    }
                    : undefined
                }
            />
        </span>
    );
};
